<template>
  <div class="foot-group-btn " @click="toAppointment" v-if="type==='appointment'">
    <span class="iconfont btn-icon icon-left "></span>
    <span class="appointment-text">我要预约</span>
  </div>
  <div class="foot-group-btn " @click="toRecord" v-else-if="type==='record'">
    <span class="record-text">预约记录</span>
    <span class="iconfont btn-icon icon-right"></span>
  </div>
  <div class="foot-group-btn " @click="toTeam" v-else-if="type==='team'">
    <span class="record-text">团队预约</span>
    <span class="iconfont btn-icon icon-right"></span>
  </div>
  <div class="foot-group-btn " @click="toHome" v-else-if="type==='home'">
    <span class="record-text">首页</span>
    <span class="iconfont btn-icon icon-right"></span>
  </div>
</template>

<script>
export default {
  name: "foot-btn",
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    toAppointment () {
      this.$router.push({name: 'Appointment'})
    },
    toRecord () {
      this.$router.push({name: 'record-query'})
    },
    toTeam () {
      this.$router.push({name: 'teamAppointment'})
    },
    toHome () {
      this.$router.push({name: 'Home'})
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/mobile/comp/foot-btn.vue
